export default __webpack_public_path__ + "static/media/installation_firefox1.6b21e9a1.jpg";